// Transform function is simplified - PDF now uses formData directly
// This is kept for backwards compatibility but can be removed
export const transformForPDF = (formData) => {
  // Return the data as-is since the PDF template now handles it directly
  return formData;
};
